import React from 'react';
import { Component } from 'react';
//import * as HelperFunctions from '../../common/helperFunctions';
import ReactPlayer from 'react-player'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

interface IProps {
    history?: any,
    lang: string
}

interface IState {
    isLoading: boolean;
    loadingPercent: number;
    isUserInteracting: boolean;
    activeTab: number;
}

const tabs = [
    { label: 'Introduction', value: 0 },
    { label: 'Cameras', value: 1 }
];

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === 0
                ?
                <Box>
                    {/* <h3>INTRODUCTION VIDEO</h3> */}
                    <ReactPlayer url='https://www.youtube.com/watch?v=C4qY6x4MvB8' controls />
                    {/* <ReactPlayer url='https://www.youtube.com/watch?v=C4qY6x4MvB8' controls /> */}
                    {/* <ReactPlayer url='https://www.radiantmediaplayer.com/media/bbb-360p.mp4' controls /> */}
                </Box>
                :
                <Box>
                    {/* <h3>CAMERAS</h3> */}
                </Box>

            }
        </div>
    );
}

class VideoStreamingComponent extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            isLoading: true,
            loadingPercent: 0,
            isUserInteracting: false,
            activeTab: 0,
        }
    }

    componentDidMount() {

        // window.addEventListener("resize", this.onWindowResize, false);
        // window.addEventListener('mousedown', this.onPointerStart, false);
        // window.addEventListener('mousemove', this.onPointerMove, false);
        // window.addEventListener('mouseup', this.onPointerUp, false);
        // window.addEventListener('wheel', this.onDocumentMouseWheel, false);
        // window.addEventListener('touchstart', this.onPointerStart, false);
        // window.addEventListener('touchmove', this.onPointerMove, false);
        // window.addEventListener('touchend', this.onPointerUp, false);

    }

    componentWillUnmount() {

        // window.removeEventListener("resize", this.onWindowResize, false);
        // window.removeEventListener('mousedown', this.onPointerStart, false);
        // window.removeEventListener('mousemove', this.onPointerMove, false);
        // window.removeEventListener('mouseup', this.onPointerUp, false);
        // window.removeEventListener('wheel', this.onDocumentMouseWheel, false);
        // window.removeEventListener('touchstart', this.onPointerStart, false);
        // window.removeEventListener('touchmove', this.onPointerMove, false);
        // window.removeEventListener('touchend', this.onPointerUp, false);

    }

    initLoading = () => {

    }


    handleChange = (event, value) => {
        this.setState({
            activeTab: value
        })
    }

    render() {
        return (
            <>
                <div style={{ marginBottom: 50, marginTop: 50, marginLeft: 50 }}>
                    <Tabs value={this.state.activeTab} onChange={(e, v) => this.handleChange(e, v)} aria-label="simple tabs example">
                        <Tab label={tabs[0].label} value={tabs[0].value} tabIndex={0} />
                        <Tab label={tabs[1].label} value={tabs[1].value} tabIndex={1} />
                    </Tabs>
                    <TabPanel value={this.state.activeTab} index={0}>
                    </TabPanel>
                    <TabPanel value={this.state.activeTab} index={1}>
                    </TabPanel>
                </div>
            </>
        );
    }

}

export default VideoStreamingComponent;
